import { render, staticRenderFns } from "./App.vue?vue&type=template&id=733217d2&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../data/code/fc/dpp/dppofficialwebsitev2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports